import Rest from '@/services/Rest';

export default class UtilService extends Rest {
  static resource = 'util';
}
